import React from 'react';
import ContactForm from '../forms/contact';

interface ContactModalProps {
  show: boolean;
  onClose: () => void;
  type: 'sales' | 'feedback';
}

const ContactModal: React.FC<ContactModalProps> = ({ show, onClose, type }) => {
  if (!show) return null;

  const getModalContent = () => {
    switch (type) {
      case 'sales':
        return {
          title: 'CONTACT SALES',
          description: 'Thank you for your interest, please fill out the form and our sales team will contact you.'
        };
      case 'feedback':
        return {
          title: 'FEEDBACK',
          description: 'Use the form below to send us your comments. We read all feedback carefully, but we are unable to respond to each submission individually. If you provide your email address, you agree that we may contact you to better understand the comments you submitted.'
        };
      default:
        return {
          title: 'CONTACT US',
          description: 'Please fill out the form below.'
        };
    }
  };

  const { title, description } = getModalContent();

  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1040 }}
        onClick={onClose}
      ></div>
      <div
        className="modal fade show"
        style={{ display: 'block', zIndex: 1050 }}
        tabIndex={-1}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '20px', paddingLeft: '2rem', paddingRight: '4rem' }}>
            <button
              type="button"
              className="btn-close"
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
              }}
              onClick={onClose}
            ></button>
            <div className="modal-header" style={{ border: 'none' }}>
              <div className="w-100 mt-3">
                <h2 className="modal-title mb-3" style={{
                  color: "#0027B0",
                  fontSize: '1.125rem',
                  fontWeight: 'bold',
                }}>{title}</h2>
                <p className="" style={{
                  color: '#000000',
                  fontSize: '0.813rem',
                  fontWeight: 'normal',
                }}>
                  {description}
                </p>
              </div>
            </div>
            <div className="modal-body">
              <ContactForm type={type} onSuccess={onClose} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactModal;